import React from 'react';

export const Chevron = ({ open }) => (
    <svg width="16" height="16" viewBox="0 0 256 256" aria-hidden="true" style={{ flex: '0 0 16px' }}>
        <polyline
            points={open ? '208 160 128 80 48 160' : '208 96 128 176 48 96'}
            fill="none"
            stroke="rgb(61,62,85)"
            strokeWidth="16"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
